module.exports = __webpack_public_path__ + "img/super_video_play.20f31f1e.png";